import classnames from 'classnames';
import React, { useState } from 'react';
import './index.less';
import { ITabItemProps } from './interface';

interface ITabsProps {
    /**
     * tabs数据
     */
    data: ITabItemProps[];

    /**
     * 默认的活跃项
     */
    defaultActiveIndex?: number;

    /**
     * 活跃tab
     */
    activeIndex?: number;

    /**
     * 点击tab
     */
    handleTabClick?: (key: string) => void;

    /**
     * tabs宽度
     */
    tabsWidth?: string;

    /**
     * tabs高度
     */
    tabsHeight?: string;

    /**
     * 是否禁用
     */
    disabled?: boolean;

    /**
     * 是否需要内容
     */
    showContent?: boolean;
}

export const Tabs: React.FC<ITabsProps> = ({
    data,
    handleTabClick,
    tabsWidth = '100%',
    tabsHeight = '26px',
    defaultActiveIndex = 1,
    activeIndex,
    disabled = false,
    showContent = true,
}) => {
    const [_activeIndex, setActiveIndex] = useState(defaultActiveIndex || 1);

    const tabClick = (index: number, key: string) => {
        handleTabClick?.(key);

        if (activeIndex === undefined) {
            setActiveIndex(index);
        }
    };

    return (
        <div
            className={classnames({
                'b-custom-tabs': true,
                disabled,
            })}
        >
            <div
                className="b-custom-tabs__header"
                style={{
                    width: tabsWidth,
                    height: tabsHeight,
                }}
            >
                {data.map(({ name = '', headerContent = null, tabKey = '', disabled }, index) => {
                    return (
                        <div
                            onClick={() => {
                                tabClick(index + 1, tabKey);
                            }}
                            className={classnames({
                                item: true,
                                active: (activeIndex === undefined ? _activeIndex : activeIndex) === index + 1,
                                disabled,
                            })}
                            key={tabKey || `tab-index-${index}`}
                        >
                            {headerContent ? headerContent : name}
                        </div>
                    );
                })}
            </div>

            {showContent ? (
                <div className="b-custom-tabs__content">
                    {data.map(({ content = null, tabKey }, index) => {
                        return (
                            <div
                                className={classnames({
                                    item: true,
                                    active: (activeIndex === undefined ? _activeIndex : activeIndex) === index + 1,
                                })}
                                key={tabKey || `tab-index-${index}`}
                            >
                                {content}
                            </div>
                        );
                    })}
                </div>
            ) : null}
        </div>
    );
};

// export default Tabs;
